// Egen locale-fil med initializer för svenska.

import { Validator } from 'vee-validate';

//import { formatFileSize, isDefinedGlobally } from './utils';


const messages = {
	after: (field, [target]) => `Måste vara efter ${target}.`,		//`Fältet ${field} måste vara efter ${target}.`,
	alpha: (field) => 'Får bara innehålla bokstäver.',		//`Fältet ${field} får bara innehålla alfabetiska tecken.`,
	alpha_dash: (field) => 'Får bara innehålla bokstäver, sned- och understreck.',		//`Fältet ${field} får bara innehålla alfanumeriska tecken såväl som snedstreck och understreck.`,
	alpha_num: (field) => 'Får bara innehålla bokstäver och siffror.',		//`Fältet ${field} får bara innehålla alfanumeriska tecken.`,
	alpha_spaces: (field) => 'Får bara innehålla bokstäver, siffror och mellanslag.',		//`Fältet ${field} får bara innehålla alfabetiska tecken och mellanslag.`,
	before: (field, [target]) => `Måste vara tidigare än ${target}.`,		//`Fältet ${field} måste vara tidigare än ${target}.`,
	between: (field, [min, max]) => `Måste vara mellan ${min} och ${max}.`,		//`Fältet ${field} måste vara mellan ${min} och ${max}.`,
	confirmed: (field, [target]) => `Matchar inte ${target}.`,		//`Fältet ${field} matchar inte ${target}.`,
	credit_card: (field) => 'Kortnumret är felaktigt',		//`The ${field} field is invalid.`,
	date_between: (field, [min, max]) => `Måste vara mellan ${min} och ${max}.`,		//`Fältet ${field} måste vara mellan ${min} och ${max}.`,
	date_format: (field, [target]) => `Måste ha formatatet ${target}.`,		//`Fältet ${field} måste ha formatatet ${target}.`,
	decimal: (field, [decimals = '*'] = []) => `Måste vara ett tal${(decimals === '*' ? '' : ' med högst ' + decimals + ' decimaler')}.`,		//`Fältet ${field} måste vara numeriskt och får innehålla ${(decimals === '*' ? '' : decimals)} decimaltecken.`,
	digits: (field, [length]) => `Måste vara ett tal med exakt ${length} siffor.`,		//`Fältet ${field} måste vara numeriskt och innehålla exakt ${length} siffor.`,
	dimensions: (field, [width, height]) => `Måste vara ${width} pixlar bred och ${height} pixlar hög.`,		//`Fältet ${field} måste vara ${width} pixlar bred och ${height} pixlar hög.`,
	email: (field) => 'Måste vara en giltig e-postadress.',		//`Fältet ${field} måste vara en giltig e-postadress.`,
	excluded: (field) => 'Måste vara ett godkänt alternativ.',		//`Fältet ${field} måste vara ett godkänt alternativ.`,
	ext: (field) => 'Måste vara en godkänd fil.',		//`Fältet ${field} måste vara en godkänd fil.`,
	image: (field) => 'Måste vara en bildfil.',		//`Fältet ${field} måste vara en bildfil.`,
	included: (field) => 'Måste vara ett godkänt alternativ.',		//`Fältet ${field} måste vara ett godkänt alternativ.`,
	integer: (field) => 'Måste vara ett heltal',		//`The ${field} field must be an integer.`,
	ip: (field) => 'Måste vara en godkänd ip-adress.',		//`Fältet ${field} måste vara en godkänd ip-adress.`,
	length: (field, [length, max]) =>
	{
		if (max)
		{
			//return `The ${field} length must be between ${length} and ${max}.`;
			return `Måste vara mellan ${length} och ${max} tecken.`;
		}

		//return `The ${field} length must be ${length}.`;
		return `Måste vara exakt ${length} tecken.`;
	},
	max: (field, [max]) => `Högst ${max} tecken.`,		//`Får inte vara längre än ${max} tecken.`,		//`Fältet ${field} får inte vara längre än ${max} tecken.`,
	max_value: (field, [max]) => `Måste vara ${max} eller lägre.`,		//`The ${field} field must be ${max} or less.`,
	mimes: (field) => 'Måste ha en filändelse.',		//`Fältet ${field} måste ha en filändelse.`,
	min: (field, [min]) => `Minst ${min} tecken.`,		//`Måste minst vara ${min} tecken.`,		//`Fältet ${field} måste minst vara ${min} tecken.`,
	min_value: (field, [min]) => `Måste vara ${min} eller högre.`,		//`The ${field} field must be ${min} or more.`,
	numeric: (field) => 'Får bara innehålla siffror.',		//`Fältet ${field} får bara innehålla numeriska tecken.`,
	regex: (field) => 'Har ett felaktig format.',		//`Fältet ${field} har en felaktig formatering.`,
	required: (field) => 'Måste anges.',	//'Är obligatoriskt.',		//`Fältet ${field} är obligatoriskt.`,
	//size: (field, [size]) => `Fältet ${field} måste vara mindre än ${formatFileSize(size)}.`, 
	url: (field) => 'Måste vara en godkänd URL.',		//`Fältet ${field} är inte en godkänd URL.`
};

const locale = {
	name: 'sv',
	messages: messages,
	attributes: {}
};


// Enligt uppgift ska lokalisering endast ske globalt *en* (1) gång per "entry point":
// "WARNING
// Your localization logic should happen at the entry point of your application as it should be only executed once."
let redanKord = false;


export default {

	runOnce() {

		if (!redanKord)
		{
			redanKord = true;

			//if (isDefinedGlobally()) {
			//  VeeValidate.Validator.localize({ [locale.name]: locale });
			//}

			// changes the locale:
			// The validator class offers a static localize method, som vi använder
			Validator.localize('sv', locale); 
		}
	}
}
